import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TransportMethodField } from 'fields';
import { useField } from 'formik';

export default function TransportMethod() {
  const { t } = useTranslation('CreateOrder');
  const [, , { setValue }] = useField('addressNumber');

  const handleChange = useCallback(async () => {
    await setValue('');
  }, [setValue]);

  return (
    <TransportMethodField
      name="transportMethod"
      label={t('DeliveryDetails.labels.transportMethod')}
      placeholder={t('DeliveryDetails.placeholders.transportMethod')}
      onChange={handleChange}
    />
  );
}
